module.exports = __webpack_public_path__ + "img/ep-etoile.fd1f6ee9.jpg";